import React from 'react';
import * as DATA from '../utils/Data';
import './MapInfo.css';

export default ({ info }) => {
  return (
    <div className="info">
      <div className="info__header">
        <span className="point" />
        <span className="cod-mod">C.M.: {info.codigo_modular}</span>
        <button className="info-close">
          <i className="material-icons">close</i>
        </button>
      </div>
      <div className="info__main">
        <h3 className="title">I.E. {info.nombre}</h3>
        <div className="intervencion">{info.intervencion}</div>
        <div className="costo">Costo: S/. {info.costo}</div>
        {info.foto && (
          <img
            className="img"
            src={DATA.SERVER_URL + info.foto.data.url}
            alt=""
          />
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/MapInfo.js